import { Component, OnInit, Input } from '@angular/core';
import { CartComponent } from '../cart/cart.component';
import { ModalController, ToastController, AlertController } from '@ionic/angular';
import { ProductsService } from '../../services/products.service';
import { GlobalService } from '../../services/global.service';
import { LoggerService } from '../../services/logger.service';
import { ApiService } from '../../api.service';
import { accountService } from 'src/app/services/account.service';
import { Carro } from './../../models/carro.model';
import { CartService } from 'src/app/services/cart.service';
import { ProductDetailsComponent } from '../product-details/product-details.component';

@Component({
    selector: 'app-orders',
    templateUrl: './orders.component.html',
    styleUrls: ['./orders.component.scss'],
})
export class OrdersComponent implements OnInit
{
    @Input() codigo: any;

    carro: Carro[] = []; // importante: inicializado
    resultado = '';
    cartItems: any[] = [];
    cartProducts: Carro;
    pregunta: boolean;

    constructor(
        private cartService: CartService,
        public alertController: AlertController,
        public global: GlobalService,
        private productsService: ProductsService,
        private logger: LoggerService,
        public modalController: ModalController,
        private apiService: ApiService,
        public accountservice: accountService,
        public toastController: ToastController
    ) { }

    // ======== GETTERS para simplificar el template y evitar carro?.[0] ========
    get pedido(): Carro | null
    {
        return (this.carro && this.carro.length) ? this.carro[0] : null;
    }

    get articulos(): any[]
    {
        const p: any = this.pedido;
        return (p && p.articulos) ? p.articulos : [];
    }

    get hasArticulos(): boolean
    {
        return this.articulos.length > 0;
    }

    // Formatea fecha YYYYMMDD -> DD/MM/YYYY (según tu uso actual)
    get fechaFormateada(): string
    {
        const p: any = this.pedido;
        const f = p.fecha;
        if (!f || String(f).length < 8) return '';
        const s = String(f);
        return `${s.substring(6, 8)}/${s.substring(4, 6)}/${s.substring(0, 4)}`;
    }

    ngOnInit()
    {
        this.logger.log(this.codigo);
        this.getPedido(this.codigo);
    }

    // Go to cart page
    async gotoCartPage()
    {
        this.dismiss();
        const modal = await this.modalController.create({
            component: CartComponent
        });
        return await modal.present();
    }

    getPedido(codigo)
    {
        this.accountservice.dameCarrito(codigo).then((products) =>
        {
            this.carro = products || [];
            for (let i = 0; i < Object.keys(this.global.cartProducts.articulos).length; i++)
            {

                let found = this.carro[0].articulos.find(x => x.codigo === this.global.cartProducts.articulos[i].codigo);
                if (found != null)
                {
                    found.cesta = true;
                    if (!this.global.carritoSumaUnidadesL06)
                    {
                        found.unid1 = this.global.cartProducts.articulos[i].unid1;
                        found.unid2 = this.global.cartProducts.articulos[i].unid2;
                    }
                }


                found = null;
            }
            this.logger.log('Mi pedido : ');
            this.logger.log(this.carro[0]);
        });
    }

    async repetir(documento)
    {
        this.alertController.create({
            header: 'Añadir productos',
            subHeader: 'Confime para continuar',
            message: '¿Está seguro de estos productos a su carro?',
            buttons: [
                {
                    text: 'Si',
                    handler: () =>
                    {
                        this.logger.log('ha dicho que si, seguimos con el pedido');
                        this.logger.log(documento);

                        let i = 0;
                        const length = documento.articulos.length;

                        for (i = 0; i < length; i++)
                        {
                            this.logger.log(documento.articulos[i].codigo);
                            this.logger.log(documento.articulos[i].unid1EnPedido);
                            this.addtocart(undefined, documento.articulos[i], documento.articulos[i].unid1EnPedido);
                        }

                        if (i === length)
                        {
                            this.confirma();
                        }
                    }
                },
                {
                    text: 'No',
                    handler: () =>
                    {
                        this.logger.log('El pedido queda en standby');
                        this.pregunta = false;
                    }
                }
            ]
        }).then(res => res.present());
    }

    async confirma()
    {
        const toast = await this.toastController.create({
            message: 'Productos añadidos a tu carrito.',
            duration: 2000
        });
        toast.present();
    }


    async addtocart(event: Event, articulo, i)
    {
        if( event != undefined )
            event.stopPropagation();
        this.logger.log("order");
        this.logger.log(articulo);
        this.logger.log(i);

        articulo = await this.apiService.dameUnidades(articulo);
        this.resultado = await this.apiService.cartAdd(articulo, false);
        this.global.searchTerm = "";
        this.logger.log(this.resultado);

        this.getCartItems(articulo.nombre);
    }

    async getCartItems(nombre)
    {
        this.cartService.cart().then((products) =>
        {
            this.cartProducts = products;
            const object = this.cartProducts.articulos;
            this.logger.log('Articulos carro: ' + object);
            this.global.artcart = Object.keys(object).length;
        });
    }

    // Back to previous page function
    dismiss()
    {
        this.modalController.dismiss({
            dismissed: true
        });
    }


    money(value: any): string
    {
        const n = Number(value);
        return n.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    /** Etiquetas opcionales para que se “lea” como en la foto */
    labelUnid1(item: any): string
    {
        // si tienes algún campo tipo "cajas/bultos" úsalo aquí
        return 'Ud.';
    }

    labelUnid2(item: any): string
    {
        // si unidadvta o unidad de medida existiera, podrías devolver "Unid." o "Kg/Lt."
        return 'Unid.';
    }

    // Go to product details page
    async goToProductDetails(item1)
    {
        // this.logger.log(codigoP);
        const modal = await this.modalController.create({
            component: ProductDetailsComponent,
            componentProps: { producto: item1 }
        });
        return await modal.present();
    }
}
